var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "question-overview" }, [
    _vm.description
      ? _c(
          "div",
          { staticClass: "question-overview__parent" },
          _vm._l(_vm.description, function (element, i) {
            return _c(
              "div",
              {
                key: "parent" + i,
                staticClass:
                  "question-overview__description canvas-element-exam",
                class: { "is-last": i === _vm.description.length - 1 },
              },
              [
                i === 0
                  ? _c("div", { staticClass: "question-overview__title" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t(
                              "$vuetify.COURSE.BASE_PDF_QUESTION_RENDERRE.LABEL_QUESTION"
                            )
                          ) +
                          " " +
                          _vm._s(_vm.question.index + 1) +
                          ": " +
                          _vm._s(_vm.generateType(_vm.question.type)) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                _c("div", { domProps: { innerHTML: _vm._s(element) } }),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }